<script setup lang="ts">
import {ref,watch,onBeforeUnmount,nextTick} from 'vue';
import {X,ChevronLeft,ChevronRight} from 'lucide-vue-next';
import type {Picture} from '../api';
import {useSite} from '../store';
const props=defineProps<{images:Picture[];index:number;title:string;open:boolean}>();
const emit=defineEmits<{'update:open':[value:boolean];'update:index':[value:number]}>();
const site=useSite(),dialog=ref<HTMLDialogElement>();let previous:HTMLElement|null=null;
function move(step:number){if(props.images.length)emit('update:index',(props.index+step+props.images.length)%props.images.length);}
function close(){emit('update:open',false);}
function key(event:KeyboardEvent){if(event.key==='ArrowRight')move(1);if(event.key==='ArrowLeft')move(-1);if(event.key==='Escape'){event.preventDefault();close();}}
watch(()=>props.open,async value=>{
  await nextTick();
  if(value){previous=document.activeElement as HTMLElement;dialog.value?.showModal();document.body.classList.add('preview-open');}
  else{dialog.value?.close();document.body.classList.remove('preview-open');previous?.focus();}
});
onBeforeUnmount(()=>document.body.classList.remove('preview-open'));
</script>
<template>
  <Teleport to="body"><dialog ref="dialog" class="image-lightbox" :aria-label="title" @keydown="key" @cancel.prevent="close" @click="(e:MouseEvent)=>{if(e.target===dialog)close()}">
    <button class="icon-button lightbox-close" :aria-label="site.text('close_preview')" @click="close"><X :stroke-width="1" :size="28" /></button>
    <button v-if="images.length>1" class="icon-button lightbox-prev" :aria-label="site.text('previous_image')" @click="move(-1)"><ChevronLeft :stroke-width="1" :size="34"/></button>
    <img v-if="images[index]" :src="images[index].url" :alt="images[index].alt||title" loading="lazy">
    <button v-if="images.length>1" class="icon-button lightbox-next" :aria-label="site.text('next_image')" @click="move(1)"><ChevronRight :stroke-width="1" :size="34"/></button>
    <div class="lightbox-caption">{{title}}<span>{{index+1}} / {{images.length}}</span></div>
  </dialog></Teleport>
</template>
